module.exports = __webpack_public_path__ + "static/img/Jason-Johanissen.939c87c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jason-Johanissen.jpg
// module id = VmsW
// module chunks = 0